export function getHttpErrorStatus(error: unknown): number | undefined {
  const candidate = error as {
    response?: { status?: number };
    status?: number;
  } | null;

  return candidate?.response?.status ?? candidate?.status;
}

export function isNotFoundError(error: unknown) {
  return getHttpErrorStatus(error) === 404;
}

export function isTermsAcceptancePath(pathname: string) {
  return /^\/terms\/?$/.test(pathname);
}

export function shouldRedirectToTerms(
  latestTermId: string | undefined,
  acceptanceError: unknown,
) {
  return Boolean(latestTermId && isNotFoundError(acceptanceError));
}
